var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product
    ? _c(
        "div",
        {
          staticClass: "pdp-form pdp-form--hide-buy-online",
          attrs: { novalidate: "" }
        },
        [
          _c("product-info", {
            attrs: {
              product: _vm.product,
              price: _vm.price,
              comparePrice: _vm.comparePrice,
              "nutritional-disclaimer": _vm.nutritionalDisclaimer,
              "nutrition-facts-visible": _vm.nutritionFactsVisible,
              "variant-title": _vm.currentVariantTitle
            }
          }),
          _c(
            "form",
            {
              staticClass: "pdp-form__add-to-cart",
              attrs: { novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.addToCart.apply(null, arguments)
                }
              }
            },
            [
              _vm.hasVariants
                ? _c("option-select-buttons", {
                    attrs: {
                      label: _vm.product.options[0],
                      product: _vm.product,
                      "data-value": _vm.selectedOption1,
                      option: "option1"
                    },
                    model: {
                      value: _vm.selectedOption1,
                      callback: function($$v) {
                        _vm.selectedOption1 = $$v
                      },
                      expression: "selectedOption1"
                    }
                  })
                : _vm._e(),
              _vm.product.options.length > 1
                ? _c("option-select-buttons", {
                    attrs: {
                      label: _vm.product.options[1],
                      product: _vm.product,
                      "data-value": _vm.selectedOption2,
                      option: "option2"
                    },
                    model: {
                      value: _vm.selectedOption2,
                      callback: function($$v) {
                        _vm.selectedOption2 = $$v
                      },
                      expression: "selectedOption2"
                    }
                  })
                : _vm._e(),
              _vm.product.options.length > 2
                ? _c("option-select-buttons", {
                    attrs: {
                      label: _vm.product.options[2],
                      product: _vm.product,
                      "data-value": _vm.selectedOption3,
                      option: "option3"
                    },
                    model: {
                      value: _vm.selectedOption3,
                      callback: function($$v) {
                        _vm.selectedOption3 = $$v
                      },
                      expression: "selectedOption3"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }